var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.562,
    height: 10.231,
    viewBox: "0 0 13.562 10.231",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19071",
    "data-name": "Path 19071",
    d: "M12.929,14.017l6.027-6.138,2.009,2.046-8.036,8.186L7.4,12.482l2.01-2.046,3.516,3.581Z",
    transform: "translate(-7.403 -7.879)",
    fill: "#130f3f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.dea5249e7aa6e8f64af0994ada63fe39.svg";
export { ForwardRef as ReactComponent };